<div class="products-item-price" [ngClass]="[componentClasses, isItemCut ? 'price-strikethrough': '']">
    <ng-container *ngIf="!priceRange; else priceRangeView">
<!--        <span *ngIf="originalVisible" class="price"-->
<!--          [ngClass]="{'has-discount': hasDiscount || hasOriginalPrice}">{{computedOriginalPrice | currency}}</span>-->
<!--        <span *ngIf="hasDiscount || hasOriginalPrice" class="price discount">{{computedDiscountedPrice | currency}}</span>-->

        <div class="d-flex flex-column">
            <span class="label text-center" *ngIf="showLabelFrom">FROM</span>
            <span *ngIf="originalVisible" class="price" [ngClass]="{'has-discount': hasDiscount || hasOriginalPrice}">
                <app-currency-price
                        [price]="computedOriginalPrice" [currency]="currency" [solelySymbol]="solelySymbol" [isItemCut]="isItemCut"></app-currency-price>
            </span>
                <span *ngIf="hasDiscount || hasOriginalPrice" class="price discount">
                <app-currency-price
                        [price]="computedDiscountedPrice" [currency]="currency" [solelySymbol]="solelySymbol" [isItemCut]="isItemCut"></app-currency-price>
            </span>
        </div>
    </ng-container>
</div>

<ng-template #priceRangeView>
    <div class="price-range-row">
        <div class="d-flex flex-column">
            <span *ngIf="originalMinVisible" class="price m-0"
                  [ngClass]="{'has-discount': hasDiscount || hasOriginalMinPriceRange}">
                <app-currency-price
                        [price]="computedOriginalMinPriceRange"
                        [currency]="currency"
                        [solelySymbol]="true"
                        [isItemCut]="isItemCut">
                </app-currency-price>
            </span>
            <span *ngIf="hasDiscount || hasOriginalMinPriceRange" class="price discount">
                <app-currency-price
                        [price]="computedDiscountedMinPriceRange"
                        [currency]="currency"
                        [solelySymbol]="true"
                        [isItemCut]="isItemCut">
                </app-currency-price>
            </span>
        </div>
        <ng-container *ngIf="priceRange?.max">
            <span class="range-separator">-</span>
            <div class="d-flex flex-column">
                <span *ngIf="originalMaxVisible || hasOriginalMaxPriceRange" class="price m-0"
                      [ngClass]="{'has-discount': hasDiscount || hasOriginalMaxPriceRange}">
                    <app-currency-price
                            [price]="computedOriginalMaxPriceRange"
                            [currency]="currency"
                            [solelySymbol]="true"
                            [isItemCut]="isItemCut">
                    </app-currency-price>
                </span>
                <span *ngIf="hasDiscount || hasOriginalMaxPriceRange" class="price discount">
                    <app-currency-price
                            [price]="computedDiscountedMaxPriceRange"
                            [currency]="currency"
                            [solelySymbol]="true"
                            [isItemCut]="isItemCut">
                    </app-currency-price>
                </span>
            </div>
        </ng-container>
        <span class="currency-code" *ngIf="!solelySymbol">
            {{ currency?.code}}
        </span>
    </div>
</ng-template>
